import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "role-module-wrapper" }
const _hoisted_2 = { class: "section-intro-bar" }
const _hoisted_3 = { class: "intro-left" }
const _hoisted_4 = { class: "icon-avatar" }
const _hoisted_5 = { class: "intro-badge" }
const _hoisted_6 = { class: "role-container" }
const _hoisted_7 = { class: "role-list" }
const _hoisted_8 = { class: "role-card-banner" }
const _hoisted_9 = { class: "role-avatar-wrapper" }
const _hoisted_10 = { class: "image-fallback" }
const _hoisted_11 = {
  key: 0,
  class: "key-role-badge"
}
const _hoisted_12 = { class: "role-badge-tag" }
const _hoisted_13 = { class: "role-card-info" }
const _hoisted_14 = { class: "role-name" }
const _hoisted_15 = { class: "role-meta-chips" }
const _hoisted_16 = {
  key: 0,
  class: "chip"
}
const _hoisted_17 = {
  key: 1,
  class: "chip"
}
const _hoisted_18 = { class: "role-desc-preview" }
const _hoisted_19 = { class: "role-card-footer" }
const _hoisted_20 = { class: "add-pulsing-box" }
const _hoisted_21 = { class: "plus-circle" }
const _hoisted_22 = { class: "role_add" }
const _hoisted_23 = { class: "role_add_left" }
const _hoisted_24 = { class: "upload-section-card" }
const _hoisted_25 = { class: "uploader-wrapper" }
const _hoisted_26 = { class: "upload-inner" }
const _hoisted_27 = { class: "form-section-card" }
const _hoisted_28 = { class: "form-row" }
const _hoisted_29 = { class: "form-row" }
const _hoisted_30 = { class: "switch-control-box" }
const _hoisted_31 = { class: "role_add_right" }
const _hoisted_32 = { class: "mockup-phone" }
const _hoisted_33 = { class: "phone-screen" }
const _hoisted_34 = { class: "screen-portrait" }
const _hoisted_35 = {
  key: 1,
  class: "media-placeholder"
}
const _hoisted_36 = {
  key: 2,
  class: "mobile-key-badge"
}
const _hoisted_37 = { class: "portrait-name-floating" }
const _hoisted_38 = { class: "hero-name" }
const _hoisted_39 = { class: "hero-prof" }
const _hoisted_40 = { class: "screen-info-board" }
const _hoisted_41 = { class: "tags-row" }
const _hoisted_42 = { class: "spec-pill" }
const _hoisted_43 = { class: "v" }
const _hoisted_44 = { class: "spec-pill" }
const _hoisted_45 = { class: "v" }
const _hoisted_46 = { class: "detail-box" }
const _hoisted_47 = { class: "box-val" }
const _hoisted_48 = { class: "detail-box" }
const _hoisted_49 = { class: "box-val" }
const _hoisted_50 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserFilled = _resolveComponent("UserFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_StarFilled = _resolveComponent("StarFilled")!
  const _component_Female = _resolveComponent("Female")!
  const _component_Male = _resolveComponent("Male")!
  const _component_EditPen = _resolveComponent("EditPen")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[33] || (_cache[33] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_UserFilled)
              ]),
              _: 1
            })
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "intro-text" }, [
            _createElementVNode("h3", { class: "title" }, "剧本角色阵容配置"),
            _createElementVNode("p", { class: "desc" }, " 配置可供玩家在冒险中选择或交互的人物档案、特有技能与专属属性 ")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, "当前共 " + _toDisplayString(_ctx.roles.length) + " 位角色", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "role-card",
              key: item.roleId || index
            }, [
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "card-glass-bg" }, null, -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_image, {
                    src: item.roleImg,
                    fit: "contain",
                    class: "role-image"
                  }, {
                    error: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Avatar)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["src"])
                ]),
                (Number(item.isKeyRole) === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_StarFilled)
                        ]),
                        _: 1
                      }),
                      _cache[13] || (_cache[13] = _createElementVNode("span", null, "关键角色", -1))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, _toDisplayString(item.roleProfession || "旅行者"), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("h4", _hoisted_14, _toDisplayString(item.roleName || "未命名角色"), 1),
                _createElementVNode("div", _hoisted_15, [
                  (item.roleSex)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            (item.roleSex === '女')
                              ? (_openBlock(), _createBlock(_component_Female, { key: 0 }))
                              : (_openBlock(), _createBlock(_component_Male, { key: 1 }))
                          ]),
                          _: 2
                        }, 1024),
                        _createTextVNode(" " + _toDisplayString(item.roleSex), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (item.roleAge)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.roleAge) + " 岁", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("p", _hoisted_18, _toDisplayString(item.roleDesc || "暂无角色生平背景描述..."), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "edit-btn",
                  onClick: ($event: any) => {
                _ctx.editRole(index);
                _ctx.isUpdate = true;
              }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_EditPen)
                      ]),
                      _: 1
                    }),
                    _cache[14] || (_cache[14] = _createTextVNode(" 编辑 ", -1))
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_popconfirm, {
                  title: "确认解雇/移除该角色吗?",
                  onConfirm: ($event: any) => (_ctx.deleteRole(index))
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "del-btn",
                      circle: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Delete)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onConfirm"])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", {
            class: "role-card add-role-trigger",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openAddDialog && _ctx.openAddDialog(...args)))
          }, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Plus)
                  ]),
                  _: 1
                })
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("p", { class: "add-title" }, "加入全新角色", -1)),
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "add-subtitle" }, "点击配置立绘与专属数值", -1))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.customDraggingVisible,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.customDraggingVisible) = $event)),
      class: "custom-dragging-style",
      title: _ctx.isUpdate ? '编辑角色档案' : '录入全新角色',
      width: "960px",
      draggable: "",
      "destroy-on-close": "",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_50, [
          _createVNode(_component_el_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.customDraggingVisible = false)),
            class: "cancel-btn"
          }, {
            default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isUpdate ? _ctx.updateRole() : _ctx.addRole())),
            class: "confirm-btn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isUpdate ? "确定修改档案" : "立即创建角色"), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "sec-header" }, [
                _createElementVNode("span", { class: "sec-title" }, "角色立绘形象"),
                _createElementVNode("span", { class: "sec-sub" }, "建议尺寸 1080×1920px (支持 JPG/PNG/WEBP，≤5MB)")
              ], -1)),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_el_upload, {
                  "file-list": _ctx.fileList,
                  "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fileList) = $event)),
                  action: _ctx.UpdateApi,
                  "list-type": "picture-card",
                  "on-success": _ctx.handleAvatarSuccess,
                  "before-upload": _ctx.beforeAvatarUpload,
                  "before-remove": _ctx.handleBeforeRemove,
                  limit: 1,
                  class: "role-uploader-box"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Plus)
                        ]),
                        _: 1
                      }),
                      _cache[18] || (_cache[18] = _createElementVNode("span", null, "点击上传立绘", -1))
                    ])
                  ]),
                  _: 1
                }, 8, ["file-list", "action", "on-success", "before-upload", "before-remove"])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_el_form, {
                model: _ctx.form,
                "label-width": "auto",
                "label-position": "top",
                class: "clean-form"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_el_form_item, {
                      label: "角色姓名",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.name,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.name) = $event)),
                          placeholder: "例如：林九霄",
                          maxlength: "20",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "身份/职业" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.profession,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.profession) = $event)),
                          placeholder: "例如：古董鉴定师",
                          maxlength: "20",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_el_form_item, { label: "性别" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.sex,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.sex) = $event)),
                          placeholder: "男 / 女 / 未知",
                          maxlength: "10"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "年龄" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.age,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.age) = $event)),
                          placeholder: "例如：24",
                          maxlength: "10"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "剧情关键角色",
                      class: "key-role-switch-item"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.form.isKeyRole,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.isKeyRole) = $event)),
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "是",
                            "inactive-text": "否",
                            "inline-prompt": ""
                          }, null, 8, ["modelValue"]),
                          _cache[20] || (_cache[20] = _createElementVNode("span", { class: "switch-tip" }, "核心主线人物", -1))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_el_form_item, { label: "专属特长或技能" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.skill,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.skill) = $event)),
                        type: "textarea",
                        rows: 2,
                        placeholder: "例如：擅长机关辨识与夜行，可解读上古密文...",
                        "show-word-limit": "",
                        maxlength: "200"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "人物生平与背景" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.desc,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.desc) = $event)),
                        type: "textarea",
                        rows: 3,
                        placeholder: "简述人物的性格特征、动机暗线与阵营关系...",
                        "show-word-limit": "",
                        maxlength: "200"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "preview-header" }, [
              _createElementVNode("span", { class: "badge-dot" }),
              _createElementVNode("span", null, "移动端角色名片视口")
            ], -1)),
            _createElementVNode("div", _hoisted_32, [
              _cache[30] || (_cache[30] = _createElementVNode("div", { class: "phone-top-bar" }, [
                _createElementVNode("div", { class: "notch" })
              ], -1)),
              _createElementVNode("div", _hoisted_33, [
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "mock-nav" }, [
                  _createElementVNode("span", { class: "nav-title" }, "人物档案")
                ], -1)),
                _createElementVNode("div", _hoisted_34, [
                  (_ctx.form.img)
                    ? (_openBlock(), _createBlock(_component_el_image, {
                        key: 0,
                        src: _ctx.form.img,
                        fit: "cover",
                        class: "portrait-img"
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createVNode(_component_el_icon, { class: "ph-icon" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Avatar)
                          ]),
                          _: 1
                        }),
                        _cache[21] || (_cache[21] = _createElementVNode("span", null, "暂未上传角色立绘", -1))
                      ])),
                  (Number(_ctx.form.isKeyRole) === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_StarFilled)
                          ]),
                          _: 1
                        }),
                        _cache[22] || (_cache[22] = _createElementVNode("span", null, "核心关键人物", -1))
                      ]))
                    : _createCommentVNode("", true),
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "portrait-gradient-layer" }, null, -1)),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.form.name || "未定名"), 1),
                    _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.form.profession || "游荡者"), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "k" }, "性别", -1)),
                      _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.form.sex || "-"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _cache[25] || (_cache[25] = _createElementVNode("span", { class: "k" }, "年龄", -1)),
                      _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.form.age || "-"), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _cache[26] || (_cache[26] = _createElementVNode("span", { class: "box-label" }, "专属能力", -1)),
                    _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.form.skill || "暂未领悟技能"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _cache[27] || (_cache[27] = _createElementVNode("span", { class: "box-label" }, "档案背景", -1)),
                    _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.form.desc || "暂未录入人物背景档案..."), 1)
                  ])
                ]),
                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "screen-footer" }, [
                  _createElementVNode("button", { class: "mock-select-btn" }, "选用此角色出发")
                ], -1))
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}